"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startProfilingContext = void 0;
const browser_core_1 = require("@datadog/browser-core");
const browser_rum_core_1 = require("@datadog/browser-rum-core");
const startProfilingContext = (hooks) => {
    // Default status is `starting`.
    let currentContext = {
        status: 'starting',
    };
    // Register the assemble hook to add the profiling context to the event attributes.
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        if (eventType !== browser_rum_core_1.RumEventType.VIEW && eventType !== browser_rum_core_1.RumEventType.LONG_TASK) {
            return browser_core_1.SKIPPED;
        }
        return {
            type: eventType,
            _dd: {
                profiling: currentContext,
            },
        };
    });
    return {
        get: () => currentContext,
        set: (newContext) => {
            currentContext = newContext;
        },
    };
};
exports.startProfilingContext = startProfilingContext;
//# sourceMappingURL=profilingContext.js.map